/* Zaturn Society — scripts propios (vanilla, sin librerías) */
(function () {
  function pad(n) { return String(n).padStart(2, '0'); }

  function initCountdowns() {
    var els = document.querySelectorAll('[data-zs-countdown]');
    if (!els.length) return;
    function tick() {
      var now = Date.now();
      els.forEach(function (el) {
        var close = parseInt(el.getAttribute('data-close'), 10) * 1000;
        var diff = Math.max(0, close - now);
        if (!close || diff <= 0) {
          el.classList.add('is-closed');
          el.textContent = el.getAttribute('data-closed-text') || '';
          return;
        }
        var s = Math.floor(diff / 1000);
        var vals = { d: Math.floor(s / 86400), h: Math.floor((s % 86400) / 3600), m: Math.floor((s % 3600) / 60), s: s % 60 };
        for (var k in vals) {
          var n = el.querySelector('[data-unit="' + k + '"]');
          if (n) n.textContent = pad(vals[k]);
        }
      });
    }
    tick();
    setInterval(tick, 1000);
  }

  function initReveal() {
    var els = document.querySelectorAll('.zs-reveal');
    if (!els.length) return;
    if (!('IntersectionObserver' in window)) { els.forEach(function (e) { e.classList.add('is-visible'); }); return; }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('is-visible'); io.unobserve(en.target); }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    els.forEach(function (el, i) { el.style.transitionDelay = (i % 4) * 70 + 'ms'; io.observe(el); });
  }

  function initFilters() {
    document.querySelectorAll('[data-zs-filter]').forEach(function (root) {
      if (root.__zsFilter) return; root.__zsFilter = true;
      var chips = root.querySelectorAll('.zs-chip');
      var items = root.querySelectorAll('[data-year]');
      chips.forEach(function (chip) {
        chip.addEventListener('click', function () {
          var f = chip.getAttribute('data-filter');
          chips.forEach(function (c) { c.classList.toggle('is-active', c === chip); });
          items.forEach(function (it) {
            var show = f === 'all' || it.getAttribute('data-year') === f;
            it.hidden = !show;
            if (show) it.classList.add('is-visible');
          });
        });
      });
    });
  }

  function initPdp() {
    document.querySelectorAll('[data-zs-pdp]').forEach(function (root) {
      if (root.__zsPdp) return; root.__zsPdp = true;
      var dataEl = root.querySelector('[data-variants]');
      if (!dataEl) return;
      var variants = JSON.parse(dataEl.textContent);
      var fieldsets = [].slice.call(root.querySelectorAll('.zs-opt'));
      var input = root.querySelector('[data-variant-input]');
      var btn = root.querySelector('[data-add]');
      var btnText = root.querySelector('[data-add-text]');
      var priceNow = root.querySelector('[data-price-now]');
      var priceCmp = root.querySelector('[data-price-compare]');
      var priceSticky = root.querySelector('[data-price-sticky]');
      var scarcity = root.querySelector('[data-scarcity]');
      var track = root.querySelector('[data-track]');
      var count = root.querySelector('[data-count]');
      var sticky = root.querySelector('[data-sticky]');
      var d = root.dataset;
      var leftUnder = parseInt(d.leftUnder, 10) || 0;

      function chosen() {
        return fieldsets.map(function (fs) {
          var c = fs.querySelector('input:checked');
          return c ? c.value : null;
        });
      }
      function findVariant(sel) {
        return variants.filter(function (v) { return v.options.every(function (o, i) { return sel[i] === o; }); })[0];
      }
      function scrollToMedia(id) {
        if (!id || !track) return;
        var slide = track.querySelector('[data-media-id="' + id + '"]');
        if (!slide) return;
        if (window.matchMedia('(min-width: 990px)').matches) {
          slide.scrollIntoView({ behavior: 'smooth', block: 'center' });
        } else {
          track.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      }
      function update(fromUser) {
        var sel = chosen();
        fieldsets.forEach(function (fs, i) {
          var lab = fs.querySelector('[data-selected-label]');
          if (lab) lab.textContent = sel[i] || '';
          // disponibilidad de cada valor, según las otras opciones ya elegidas
          fs.querySelectorAll('.zs-opt__input').forEach(function (inp) {
            var test = sel.slice(); test[i] = inp.value;
            var possible = variants.filter(function (v) {
              return v.options.every(function (o, k) { return test[k] === null || test[k] === undefined || test[k] === o; });
            });
            var ok = possible.some(function (v) { return v.available; });
            var label = fs.querySelector('label[for="' + inp.id + '"]');
            if (label) label.classList.toggle('is-unavailable', !ok);
          });
        });
        var ready = sel.every(function (s) { return s !== null; });
        var v = ready ? findVariant(sel) : null;
        if (v) {
          input.value = v.id;
          if (priceNow) priceNow.textContent = v.price;
          if (priceSticky) priceSticky.textContent = v.price;
          if (priceCmp) { priceCmp.hidden = !v.compare; if (v.compare) priceCmp.textContent = v.compare; }
          delete btn.dataset.needsSize;
          if (v.available) { btn.disabled = (d.closed === 'true'); btnText.textContent = d.preorderText; }
          else { btn.disabled = true; btnText.textContent = (d.closed === 'true') ? d.preorderText : d.soldoutText; }
          if (leftUnder && v.qty > 0 && v.qty <= leftUnder) { scarcity.hidden = false; scarcity.textContent = d.leftText.replace('__N__', v.qty); }
          else scarcity.hidden = true;
          if (fromUser) scrollToMedia(v.media);
          var url = new URL(window.location.href); url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url);
        } else {
          if (d.closed === 'true') { btn.disabled = true; btnText.textContent = d.preorderText; } else { btn.disabled = false; btn.dataset.needsSize = '1'; btnText.textContent = d.selectText; } scarcity.hidden = true;
          // si ya hay color elegido, salta a su foto
          if (fromUser) { var colorFs = root.querySelector('.zs-opt[data-is-color="true"]'); if (colorFs) { var cv = variants.filter(function (x) { var i = fieldsets.indexOf(colorFs); return x.options[i] === sel[i] && x.media; })[0]; if (cv) scrollToMedia(cv.media); } }
        }
      }
      root.querySelectorAll('.zs-opt__input').forEach(function (i) { i.addEventListener('change', function () { update(true); }); });
      // sin talla elegida: el botón se ve normal y, al tocarlo, resalta las tallas en vez de comprar
      var buyForm = btn && btn.form;
      if (buyForm) buyForm.addEventListener('submit', function (e) {
        if (!btn.dataset.needsSize) return;
        e.preventDefault(); e.stopImmediatePropagation();
        var fs = fieldsets.filter(function (f) { return !f.querySelector('input:checked'); })[0] || fieldsets[0];
        if (!fs) return;
        fs.classList.add('is-nudge');
        fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
        setTimeout(function () { fs.classList.remove('is-nudge'); }, 1500);
      }, true);
      update(false);

      // contador de fotos (mobile)
      if (track && count) {
        var slides = track.children.length;
        function setCount() {
          var w = track.clientWidth || 1;
          count.textContent = (Math.round(track.scrollLeft / w) + 1) + ' / ' + slides;
        }
        track.addEventListener('scroll', setCount, { passive: true });
        setCount();
      }

      // guía de tallas
      var dlg = root.querySelector('[data-guide]');
      var open = root.querySelector('[data-open-guide]');
      if (dlg && open) {
        open.addEventListener('click', function () { if (dlg.showModal) dlg.showModal(); else dlg.setAttribute('open', ''); });
        dlg.querySelector('[data-close-guide]').addEventListener('click', function () { dlg.close(); });
        dlg.addEventListener('click', function (e) { if (e.target === dlg) dlg.close(); });
      }

      // barra fija de compra
      if (sticky && btn && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (es) {
          es.forEach(function (e) {
            var above = e.boundingClientRect.top < 0;
            sticky.classList.toggle('is-on', !e.isIntersecting && above);
          });
        });
        io.observe(btn);
        root.querySelector('[data-sticky-btn]').addEventListener('click', function () {
          var sel = chosen();
          if (sel.every(function (s) { return s !== null; })) { btn.click(); }
          else { btn.scrollIntoView({ behavior: 'smooth', block: 'center' }); }
        });
      }
    });
  }

  function initPwVideo() {
    if (!window.matchMedia || !window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
    document.querySelectorAll('.zs-pw__media video, .zs-hero video').forEach(function (v) { v.removeAttribute('autoplay'); v.pause(); });
  }

  function initDropAuto() {
    var mq = window.matchMedia ? window.matchMedia('(max-width: 749px)') : null;
    document.querySelectorAll('.zs-grid--drop').forEach(function (g) {
      if (g.dataset.zsAuto || g.children.length < 2) return;
      g.dataset.zsAuto = '1';
      var timer = null, visible = false, paused = false, resume = null;
      function step() {
        if (!mq || !mq.matches || !visible || paused || document.hidden) return;
        var cards = g.children, cur = 0, mid = g.scrollLeft + g.clientWidth / 2, best = 1e9;
        for (var i = 0; i < cards.length; i++) {
          var d = Math.abs(cards[i].offsetLeft + cards[i].offsetWidth / 2 - mid);
          if (d < best) { best = d; cur = i; }
        }
        var nxt = cards[(cur + 1) % cards.length];
        g.scrollTo({ left: nxt.offsetLeft - (g.clientWidth - nxt.offsetWidth) / 2, behavior: 'smooth' });
      }
      function pause() { paused = true; clearTimeout(resume); resume = setTimeout(function () { paused = false; }, 7000); }
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { g.addEventListener(ev, pause, { passive: true }); });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.5 }).observe(g);
      } else { visible = true; }
      timer = setInterval(step, 3800);
    });
  }

  function initLookAuto() {
    document.querySelectorAll('[data-zs-look-auto]').forEach(function (box) {
      if (box.classList.contains('is-running')) return;
      var items = Array.prototype.slice.call(box.querySelectorAll('.zs-look__item'));
      var N = items.length;
      if (N < 2) return;
      var random = box.getAttribute('data-shuffle') === 'true';
      var need = Math.max(2, Math.ceil(6 / N)); // un "set" debe ser más ancho que la pantalla
      function shuffle(a) { for (var i = a.length - 1; i > 0; i--) { var k = Math.floor(Math.random() * (i + 1)); var t = a[i]; a[i] = a[k]; a[k] = t; } return a; }
      function ids() { var a = []; for (var i = 0; i < N; i++) a.push(i); return a; }
      function sequence(prevFirst) { // nuevo orden: cada foto sale `need` veces, sin repetir la misma dos veces seguidas
        var seq = [];
        for (var r = 0; r < need; r++) {
          var perm = random ? shuffle(ids()) : ids();
          while (random && (seq.length ? perm[0] === seq[seq.length - 1] : perm[0] === prevFirst)) perm = shuffle(ids());
          seq = seq.concat(perm);
        }
        return seq;
      }
      function node(id) { var c = items[id].cloneNode(true); c.setAttribute('data-id', id); c.classList.add('is-visible'); var im = c.querySelector('img'); if (im) im.setAttribute('loading', 'eager'); return c; }
      var track = document.createElement('div'); track.className = 'zs-look__track';
      var seq = sequence(-1);
      seq.forEach(function (id) { track.appendChild(node(id)); });
      seq.forEach(function (id) { var c = node(id); c.setAttribute('aria-hidden', 'true'); track.appendChild(c); });
      box.innerHTML = ''; box.appendChild(track); box.classList.add('is-running');
      var M = seq.length, lastFirst = seq[0];
      // Movimiento con scroll nativo. Cada vuelta, el primer set pasa al final con un orden nuevo (lo que se ve no salta).
      var setW = 0, pos = 0, last = 0, pausedUntil = 0, visible = true, hover = false;
      function measure() { var k = track.children[M]; setW = k ? k.offsetLeft : 0; }
      measure(); window.addEventListener('resize', measure);
      function reorder() {
        var kids = Array.prototype.slice.call(track.children), first = kids.slice(0, M), pool = {};
        first.forEach(function (n) { var id = n.getAttribute('data-id'); (pool[id] = pool[id] || []).push(n); });
        var prev = kids.slice(M).map(function (n) { return +n.getAttribute('data-id'); });
        var ns = sequence(prev[0]), tries = 0;
        while (random && ns.join() === prev.join() && tries++ < 10) ns = sequence(prev[0]);
        ns.forEach(function (id) { var n = pool[id].pop(); n.setAttribute('aria-hidden', 'true'); track.appendChild(n); });
        Array.prototype.slice.call(track.children).slice(0, M).forEach(function (n) { n.removeAttribute('aria-hidden'); });
      }
      function pause(ms) { pausedUntil = Date.now() + ms; }
      ['touchstart', 'pointerdown', 'wheel'].forEach(function (ev) { box.addEventListener(ev, function () { pause(4000); }, { passive: true }); });
      box.addEventListener('scroll', function () { if (Date.now() < pausedUntil) pos = box.scrollLeft; }, { passive: true });
      if (window.matchMedia && window.matchMedia('(hover: hover)').matches) { box.addEventListener('mouseenter', function () { hover = true; }); box.addEventListener('mouseleave', function () { hover = false; pos = box.scrollLeft; }); }
      if ('IntersectionObserver' in window) new IntersectionObserver(function (en) { visible = en[0].isIntersecting; }, { threshold: 0.1 }).observe(box);
      var secs = parseFloat(getComputedStyle(box).getPropertyValue('--zs-look-speed')) || 45;
      if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) secs *= 2.5;
      function tick(t) {
        if (!last) last = t; var dt = Math.min((t - last) / 1000, 0.1); last = t;
        if (setW && visible && !hover && !document.hidden && Date.now() >= pausedUntil) {
          pos += (setW / secs) * dt;
          if (pos >= setW) { reorder(); pos -= setW; measure(); }
          box.scrollLeft = pos;
        } else { pos = box.scrollLeft; if (pos >= setW && setW) { reorder(); pos -= setW; box.scrollLeft = pos; measure(); } }
        requestAnimationFrame(tick);
      }
      requestAnimationFrame(tick);
    });
  }

  function init() { initPwVideo(); initCountdowns(); initReveal(); initFilters(); initPdp(); initDropAuto(); initLookAuto(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
